import Error from 'components/alerts/Error'
import { ContentLoader } from 'components/common/loader/ContentLoader';
import QRCode from 'qrcode.react';
import React from 'react';
import Moment from 'react-moment';
import { withRouter } from 'react-router';
import { fetchGraphQL } from 'services/graphql/GraphQL';

import { getByCode } from '../../../components/graphql/queries/ticket';


interface IReceiptPageProps {
  match?: any;
}

interface IReceiptPageState {
  ticket: any;
  isLoading: boolean;
  error: boolean;

  timeInfo: any;
}

class ReceiptPage extends React.Component<
  IReceiptPageProps,
  IReceiptPageState
  > {

  public state = {
    error: false,
    isLoading: true,
    timeInfo: {
      startYear: 0,
      startMonth: 0,
      startDay: 0,
      startHour: 0,
      startMinutes: 0,
      startAMPM: false,
      endYear: 0,
      endMonth: 0,
      endDay: 0,
      endHour: 0,
      endMinutes: 0,
      endAMPM: false
    },
    ticket: {
      totalPrice: 0,
      boughtAt: "",
      buyer: {
        fullName: "",
        email: ""
      },
      code: "",
      event: {
        id: '',
        name: "",
        fees: { absorb: false },
        startTime: "",
        location: "",
        creationTimeZone: "",
        currency: ''
      },
      tax: null,
      internationalCardUsed: false,
      eventId: "",
      promoter: { name: "", lastname: "" },
      totalCount: 0,
      totalPlatformFees: 0,
      totalProcessingFees: 0,
      boughtBy: { name: "" },
      ticketComponents: [
        {
          name: "",
          count: 0,
          price: 0,
          fee: 0,
          ticketBankId: ""
        }
      ]
    }
  };

  constructor(props) {
    super(props);
  }

  public componentWillMount() {
    this.fetchNeededData();
  }

  public fetchNeededData() {
    // Fetching Ticket
    fetchGraphQL(getByCode(), undefined, {
      ticketCode: this.props.match.params.ticketCode
    }).then(res => {
      // If Ticket is null then don't load other data
      if (res === null) {
        this.setState({
          isLoading: false,
          error: true
        });
        return;
      }

      // Fetching Event Details
      const titem = res.ticket.get;
      titem.promoter = { name: "", lastname: "" }

      fetchGraphQL(
        `{
            event {
                  get(eventId:"${res.ticket.get.eventId}") {
                  id
                  name,
                  startTime,
                  currency
                  location,
                  creationTimeZone
                  fees {
                    absorb
                  } 
                }
              }
          }`
      ).then(result => {
        // If Event is null don't load other stuff
        if (result !== null) {
          this.setState({
            ticket: {
              ...titem, event: {
                ...result.event.get,
                currency: result.event.get.currency ? result.event.get.currency : 'USD'
              }
            },
          });
        } else {
          this.setState({
            isLoading: false
          });
          return;
        }
        // Fetching promoterId
        fetchGraphQL(
          `{
            ticketBank {
              get(eventId:"${res.ticket.get.eventId}") {
                promoterId
                _id
              }
            }
          }`
        ).then(result2 => {
          // If ticketBank does not exist (weird case but still) don't load other stuff
          if (result2 !== null) {

            const promoter = result2.ticketBank.get.filter((obj) => {
              return (obj._id === this.state.ticket.ticketComponents[0].ticketBankId)
            })

            // If promoter sold the ticket 
            if (promoter !== undefined && promoter.length > 0) {
              const promoterId = promoter[0].promoterId;
              // Fetch promoter
              fetchGraphQL(
                `{
						        user {
							        findById(id:"${promoterId}") {
								        name
							          lastname
							        }		
						        }
                  }`
              ).then(result3 => {
                if (result3 !== null) {
                  this.setState({ ticket: { ...this.state.ticket, promoter: result3.user.findById } });
                }
              });
            }

          }

          fetchGraphQL(
            `
            query {
              time {
                findByEventId(id:"${res.ticket.get.eventId}") {
                  startYear
                  startMonth
                  startDay
                  startHour
                  startMinutes
                  startAMPM
                  endYear
                  endMonth
                  endDay
                  endHour
                  endMinutes
                  endAMPM
                }
              }
            }
            `).then((time => {
              this.setState({ timeInfo: time.time.findByEventId, isLoading: false });
            }))

        });

      });
    });
  }

  public render() {

    const { ticket, timeInfo } = this.state;

    let totalTicket = 0;
    ticket.ticketComponents.forEach((item: any) => {
      totalTicket += item.count;
    });

    const subtotal = ticket.tax === null ? (
      (ticket.totalPrice -
        ticket.totalPlatformFees - ticket.totalProcessingFees) /
      100
    ).toFixed(2) :
      (
        (ticket.totalPrice -
          ticket.totalPlatformFees - ticket.totalProcessingFees - ticket.tax!) /
        100
      ).toFixed(2)

    let month = ''
    const monthNum = String(timeInfo.startMonth);

    switch (monthNum) {
      case ('1'):
        month = 'January'
        break;
      case ('2'):
        month = 'February'
        break;
      case ('3'):
        month = 'March'
        break;
      case ('4'):
        month = 'April'
        break;
      case ('5'):
        month = 'May'
        break;
      case ('6'):
        month = 'June'
        break;
      case ('7'):
        month = 'July'
        break;
      case ('8'):
        month = 'August'
        break;
      case ('9'):
        month = 'September'
        break;
      case ('10'):
        month = 'October'
        break;
      case ('11'):
        month = 'November'
        break;
      case ('12'):
        month = 'December'
        break;
    }

    const startTime = month + ' ' + String(timeInfo.startDay) + ', ' + String(timeInfo.startYear) + ' ' +
      String(timeInfo.startHour) + ':' + (timeInfo.startMinutes / 10 < 1 ? String(timeInfo.startMinutes) + '0' : String(timeInfo.startMinutes))

    const content = this.state.error === false
      ?
      <div className="div_holder_2">
        <p><br /></p>
        <div
          className="div_holder_4 card"
          style={{
            color: "black"
          }}
        >
          <p />
          <div
            className="col-sm-12 pt-2"
            style={{
              display: "flex",
              justifyContent: "center",
              paddingLeft: '10%', paddingRight: '10%'
            }}
          >
            <div
              className="row pt-3"
              style={{ maxWidth: "800px", }}
            >
              <div className="col text-center">
                <h1 className="sexyBlack pb-2">{ticket.event.name}</h1>
                <h6 style={{ textAlign: 'center' }} className="sexyBlack">
                  <strong>
                    Order Confirmed<br />
                    <small>Check email for ticket confirmation</small><br /><br />
                  </strong>
                </h6>
                <blockquote className="text-gray" style={{ paddingRight: '5%', paddingLeft: '5%', fontSize: '11px' }}>
                  Your tickets have been sent to your email. Please save or
                  screenshot this page for record if you have not
                  received an email with your ticket from
                  orders@isotopeticketing.com
                  </blockquote>

                <div className="row" style={{ paddingRight: '5%', paddingLeft: '5%' }}>
                  <div className="col-md-6 col-lg-6 col-sm-6 pb-3">
                    <QRCode
                      renderAs="svg"
                      value={"http://istkt.com/" + ticket.code}
                      size={220}
                    />
                  </div>
                  <div
                    className="col-md-6 col-lg-6 col-sm-6"
                    style={{
                      textAlign: "left"
                    }}
                  >
                    <p>
                      <b className="text-gray pr-2">Ticket ID</b>
                      <span className="ticket-info right">
                        {" "}
                        {ticket.code}
                      </span>
                    </p>

                    <p>
                      <b className="text-gray pr-2">Buyer name</b>
                      <span className="ticket-info right">
                        {" "}
                        {ticket.buyer ? ticket.buyer.fullName : ""}
                      </span>
                    </p>

                    <p>
                      <b className="text-gray pr-2">Event address</b>
                      <span className="ticket-info right">
                        {" "}
                        {ticket.event.location}
                      </span>
                    </p>

                    <p>
                      <b className="text-gray pr-2">Event time</b>
                      <span className="ticket-info right">
                        {
                          startTime
                        }
                        {timeInfo.startAMPM ? 'PM' : 'AM'}
                      </span>
                    </p>

                    {ticket.promoter !== null ? (
                      <p className="promoter-field">
                        <b className="text-gray pr-2">Sales Channel</b>
                        <span className="ticket-info right">
                          {" "}
                          {ticket.promoter.name || "General Ticket"}{" "}
                          {ticket.promoter.lastname || ""}
                        </span>
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-12 col-lg-12 col-sm-12">
                  {
                    this.state.ticket.event.id === '5dcfc36b02881a24a2e7c402' ? null
                      :
                      <table className="table">
                        <tr>
                          <th className="text-left">TICKET TYPE</th>
                          <th className="text-center">QUANTITY</th>
                          <th className="text-center">PRICE</th>
                        </tr>
                        {
                          ticket.ticketComponents.map(component => {
                            return (
                              <tr key={"aaa" + component.name}>
                                <td className="text-left">{component.name}</td>
                                <td className="text-center">{component.count}</td>
                                <td className="text-center">
                                  {
                                    this.state.ticket.event.currency === 'INR' ? <span>&#8377;</span> : '$'
                                  }
                                  {(component.price / 100).toFixed(2)}
                                </td>
                              </tr>
                            );
                          })}

                        {ticket.event.fees.absorb === false ? (
                          <React.Fragment>
                            <tr
                              style={{
                                backgroundColor: "#F1F1F1"
                              }}
                            >
                              <th className="text-left"><b>Subtotal</b></th>
                              <td className="text-center">
                                {totalTicket}
                              </td>
                              <td className="text-center">
                                <b>
                                  {
                                    this.state.ticket.event.currency === 'INR' ? <span>&#8377;</span> : '$'
                                  }
                                  {subtotal}
                                </b>
                              </td>
                            </tr>
                            <tr
                              style={{
                                backgroundColor: "#F1F1F1"
                              }}
                            >
                              <th className="text-left">Service Fees</th>
                              <td className="text-center" />
                              <td className="text-center">
                                {
                                  this.state.ticket.event.currency === 'INR' ? <span>&#8377;</span> : '$'
                                }
                                {(ticket.totalPlatformFees / 100).toFixed(2)}
                              </td>
                            </tr>
                            <tr
                              style={{
                                backgroundColor: "#F1F1F1"
                              }}
                            >
                              <th className="text-left">Card Processing Fees</th>
                              <td className="text-center" />
                              <td className="text-center">
                                {" "}
                                {
                                  this.state.ticket.event.currency === 'INR' ? <span>&#8377;</span> : '$'
                                }
                                {
                                  (ticket.totalProcessingFees / 100).toFixed(2)
                                }
                                {" "}
                              </td>
                            </tr>
                            {
                              ticket.tax === undefined || ticket.tax === null || ticket.tax === 0 || Number(ticket.tax) === 0 ? null :
                                <tr
                                  style={{
                                    backgroundColor: "#F1F1F1"
                                  }}
                                >
                                  <th className="text-left">Tax</th>
                                  <td className="text-center" />
                                  <td className="text-center">
                                    {" "}
                                    {
                                      this.state.ticket.event.currency === 'INR' ? <span>&#8377;</span> : '$'
                                    }
                                    {
                                      (ticket.tax! / 100).toFixed(2)
                                    }
                                    {" "}
                                  </td>
                                </tr>
                            }
                            <tr
                              style={{
                                backgroundColor: "#F1F1F1"
                              }}
                            >
                              <th className="text-left"><b>Total Amount Paid</b></th>
                              <td className="text-center" />
                              <td className="text-center">
                                <b>
                                  {
                                    this.state.ticket.event.currency === 'INR' ? <span>&#8377;</span> : '$'
                                  }
                                  {
                                    (ticket.totalPrice / 100).toFixed(2)
                                  }
                                </b>
                              </td>
                            </tr>
                          </React.Fragment>
                        ) : (
                            <React.Fragment>
                              <tr
                                style={{
                                  backgroundColor: "#F1F1F1"
                                }}
                              >
                                <th className="text-left"><b>Total Amount Paid</b></th>
                                <td className="text-center">
                                  {totalTicket}
                                </td>
                                <td className="text-center">
                                  <b>
                                    {
                                      this.state.ticket.event.currency === 'INR' ? <span>&#8377;</span> : '$'
                                    }
                                    {(
                                      ticket.totalPrice /
                                      100
                                    ).toFixed(2)}
                                  </b>
                                </td>
                              </tr>
                            </React.Fragment>
                          )
                        }
                      </table>}
                  <p />
                  <hr />
                  <p className="text-left">
                    <b className="text-gray">Date and time of {Number(ticket.totalPrice) === 0 ? 'confirmation' : 'payment'} &nbsp;&nbsp;</b>
                    <span className="ticket-info right">
                      <Moment format="M.D.Y">
                        {ticket.boughtAt}
                      </Moment>
                      {" at "}
                      <Moment format="hh:mm A">
                        {ticket.boughtAt}
                      </Moment>
                    </span>
                  </p>
                  <hr />
                  <p style={{ fontSize: '11px', paddingBottom: '20px' }}>
                    For any questions regarding your order, please contact
                    us at
                  <br />
                    orders@isotopeticketing.com
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p><br /></p>
      </div>
      :
      <Error content={"Ticket Not Found"} />

    return (
      <ContentLoader isLoading={this.state.isLoading}>
        <div
          style={{
            padding: "0"
          }}
        >
          <div
            style={{
              minHeight: '110vh',
              height: 'auto',
              width: '100%',
            }}
          >
            {content}
          </div>
        </div>
      </ContentLoader>
    );
  }
}

export default withRouter(ReceiptPage);



// WEBPACK FOOTER //
// ./src/pages/ticket/receipt/Receipt.page.tsx